"use client";

import { SxProps } from "@mui/material";
import Box from "@mui/material/Box";
import Image from "next/image";
import Link from "next/link";
import { useMemo } from "react";

export interface LogoProps {
    type?: 'default' | 'text-white' | 'text-black' | 'micro' | 'mobile' | 'slogan',
    sx?: SxProps,
    href?: string,
}

function getLogoSource(type: LogoProps['type']) {
    switch (type) {
        case "text-white":
            return "/assets/logo-white.svg";
        case "text-black":
            return "/assets/logo-text.svg";
        case "micro":
            return "/assets/logo-micro.svg"
        case "mobile":
            return "/assets/logo-fit.svg";
        case "slogan":
            return "/assets/logo-slogan.svg";
        default:
            return "/assets/logo-vahdat.svg";
    }
}

export default function Logo({ type, sx, href = "/fa" }: LogoProps) {
    const src = useMemo(() => getLogoSource(type), [type])

    return (
        <Box
            component={Link}
            sx={{
                height: type === "micro" ? 24 : 56,
                aspectRatio: {
                    xs: type === "micro" ? "1 / 1" : '2.3 / 1',
                    sm: type === "micro" ? "1 / 1" : '3 / 1'
                },
                position: "relative",
                display: 'block',

                ...sx
            }}
            href={href}
            prefetch={false}
        // title={"عینک وحدت"}
        >
            <Image
                priority
                fetchPriority="high"
                fill
                style={{ objectFit: 'contain' }}
                // sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                src={src}
                alt="لوگو عینک وحدت"
            />
        </Box>
    );
}
